import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import PageLoadHandler from '../components/PageLoad/PageLoadHandler';
import useUserIdleTimer from '../hooks/useUserIdleTimer';
import Utils from '../utils';

export const PrivateRoute = ({ children, route }) => {
  const auth = Utils.getLocalStorageItem('_t') || null;
  const [isLoading, setIsLoading] = useState(true);
  const [allowAccess, setAllowAccess] = useState(false);
  const [apiInterval, setAPIInterval] = useState('');
  const userRoutes = JSON.parse(Utils.getLocalStorageItem('accessMenus') || '{}');

  async function doesRouteExist(route, menu) {
    for (const item of menu) {
      if (item.path === route) {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    const checkRoute = async () => {
      setIsLoading(true);
      if (route) {
        try {
          const response = await doesRouteExist(route, userRoutes?.menus);
          if (response) {
            setAllowAccess(true);
          } else {
            setAllowAccess(false);
          }
        } catch (error) {
          setAllowAccess(false);
        } finally {
          setIsLoading(false);
        }
      } else {
        setAllowAccess(true);
        setIsLoading(false);
      }
    };
    checkRoute();
  }, [route]);

  useUserIdleTimer(setAPIInterval, apiInterval);

  if (isLoading) {
    return <PageLoadHandler />;
  }

  if (!auth) {
    return <Navigate to='/' />;
  }

  return (
    <>{allowAccess ? children : <Navigate to='/dashboard/assistants' />}</>
  );
};
